import { api } from "../api";

export interface Weather {
  // 12小時降雨機率
  pop12h: number;
  // 最高溫度
  maxT: number;
}

export interface 城市資訊 {
  人口: 基本資料;
  土地: 基本資料;
  綠能: 綠能;
  觀光: 基本資料;
  醫療: 基本資料;
  交通: 交通;
}

export interface 交通 {
  資料來源: string;
  網址: string;
  資料集: 資料集[];
}

export interface 資料集 {
  文字: string;
  數據集: 數據集[] | null;
  數據單位: string;
  網址: string;
  數據: number | null;
}

export interface 數據集 {
  行政區: string;
  數據: number;
}

export interface 基本資料 {
  資料來源: string;
  網址: string;
}

export interface 綠能 {
  資料來源: string;
  網址: string;
  資料: 資料;
}

export interface 資料 {
  文字: string;
  數據: number;
  數據單位: string;
}

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    weatherForecast: build.query<Weather, string | void>({
      query: (locationName) => ({
        url: "/opendata/weather-forecast",
        params: { locationName: locationName || undefined },
      }),
    }),
    hotelCount: build.query<number, string | void>({
      query: (locationName) => ({
        url: "/opendata/hotel-count",
        params: { locationName: locationName || undefined },
      }),
    }),
    historicalMonumentCount: build.query<number, string | void>({
      query: (locationName) => ({
        url: "/opendata/historical-monument-count",
        params: { locationName: locationName || undefined },
      }),
    }),
    hospitalCount: build.query<number, string | void>({
      query: (locationName) => ({
        url: "/opendata/hospital-count",
        params: { locationName: locationName || undefined },
      }),
    }),
    hospitalBedCount: build.query<number, string | void>({
      query: (locationName) => ({
        url: "/opendata/hospital-bed-count",
        params: { locationName: locationName || undefined },
      }),
    }),
    population: build.query<
      {
        categories: string[];
        households: number[];
        population: number[];
        females: number[];
        males: number[];
      },
      string | void
    >({
      query: (locationName) => ({
        url: "/opendata/population",
        params: { locationName: locationName || undefined },
      }),
    }),
    landTrade: build.query<{ district: string; count: number }[], void>({
      query: () => "opendata/land-trade",
    }),
    transportation: build.query<
      {
        airline: { count: number; unit: string };
        tBike: { count: number; unit: string };
        train: { count: number; unit: string };
        bus: { count: number; unit: string };
        greenEnergy: { count: number; unit: string };
      },
      string | void
    >({
      query: (locationName) => ({
        url: "/opendata/transportation",
        params: { locationName: locationName || undefined },
      }),
    }),
    cityInfo: build.query<城市資訊, void>({
      query: () => "/opendata/city-info",
    }),
  }),
  overrideExisting: false,
});

export const {
  useWeatherForecastQuery,
  useHospitalBedCountQuery,
  useHospitalCountQuery,
  useHistoricalMonumentCountQuery,
  useHotelCountQuery,
  usePopulationQuery,
  useLandTradeQuery,
  useTransportationQuery,
  useCityInfoQuery,
} = extendedApi;
